import React, { useCallback, useEffect, useState } from "react";
import InputUnderline from "../../../components/controls/input/InputUnderline";
import ModalCheckbox from "../../../components/controls/modalcheckbox/ModalCheckbox";
import Input from "../../../components/controls/input/customInput/CustomInput";
import service from "../../../store/services/shifts.service";
import Button from "../../../components/controls/button/Button";
import { AddIconSvg, MeetingsClockIcon } from "../../../modules/default-svg";
import { ColumnConfigProvider } from "../../../components/controls/tables/ColumnConfigProvider";
import Table from "../../../components/controls/tables/Table";
import { calculatePageSize } from "../../../helpers/utils";

const Shifts = (props) => {
  const {
    createShift,
    setCreateShift,
    pageLoading,
    loading,
    pagination,
    allShifts,
    getShiftsRequest,
    createShiftRequest,
    updateShiftRequest,
    deleteShiftRequest,
    errors,
    parentType = null,
  } = props;
  const permissions = localStorage.getItem("permissions");
  const [name, setName] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [isDefault, setIsDefault] = useState(false);
  const [showIsDefault, setShowIsDefault] = useState(true);
  const [data, setData] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [perPageItems] = useState(calculatePageSize());
  const [isHeader, setIsHeader] = useState(true);
  const [isCreate, setIsCreate] = useState(false);
  const [isCreateNewRow, setIsCreateNewRow] = useState(false);
  const [deleteId, setDeletedId] = useState(null);
  const [selectedRow, setSelectedRow] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [formErrors, setFormErrors] = useState({
    name: "",
    startTime: "",
    endTime: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [tableSearch, setTableSearch] = useState(null);
  const handleSave = () => {
    if (!isDisable) {
      const errors = {};
      if (!name) errors["name"] = `The Name field is required.`;
      if (!startTime) errors["startTime"] = `The StartTime field is required.`;
      if (!endTime) errors["endTime"] = `The EndTime field is required.`;
      setFormErrors(errors);
      if (Object.keys(errors).length) {
        return;
      }
      const payload = {
        Name: name,
        StartTime: startTime,
        EndTime: endTime,
        isDefault: isDefault,
      };

      if (Object.keys(selectedRow).length > 0) {
        updateShiftRequest({ id: selectedRow.id, payload });
      } else {
        createShiftRequest({ payload });
      }
    }
  };

  const handleCancel = () => {
    setFormErrors({});
    setIsEdit(false);
  };

  const handleDelete = (selectedRow) => {
    if (!isDisable) {
      // const id = JSON.parse(localStorage.getItem("selectedRow")).id;
      const id = selectedRow.id;
      deleteShiftRequest({ id: id });
      setDeletedId(id);
      // localStorage.removeItem("selectedRow");
    }
  };

  const handleSearch = (filteredData) => {
    setData(filteredData);
  };

  const fetchShiftData = async () => {
    setIsLoading(true);
    // setShowIsDefault(false);
    service
      .fetchSingleShiftRequest(selectedRow.id)
      .then((shiftData) => {
        setName(shiftData.name);
        setStartTime(shiftData.startTime);
        setEndTime(shiftData.endTime);
        setIsDefault(shiftData.isDefault);
        shiftData.isDefault ? setShowIsDefault(false) : setShowIsDefault(true);
        // setTimeout(() => {
        setIsLoading(false);
        // }, 3000);
      })
      .catch((error) => console.error("Error fetching data:", error));
  };

  const handleCreate = () => {
    setIsCreate(true);
  };

  useEffect(() => {
    if (Object.keys(selectedRow).length > 0) {
      isEdit && fetchShiftData();
    } else {
      setName("");
      setStartTime("");
      setEndTime("");
      setIsDefault(false);
      setShowIsDefault(true);
    }
  }, [selectedRow, isEdit]);

  const fetchData = (pageNumber, pageSize, searchTerm, forceClearSearch=false) => {
    const payload = { page: pageNumber ?? pageNum, size: pageSize ?? perPageItems, search: forceClearSearch ? null : (searchTerm ?? tableSearch) };
    getShiftsRequest(payload);
  };

  const handleCancelAddRow = () => {
    setIsCreateNewRow(false);
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, [pageNum, perPageItems]);

  useEffect(() => {
    if (allShifts && allShifts.length > 0) {
      if (isCreateNewRow) {
        setData(
          allShifts.sort((a, b) => {
            return b.isFlagged - a.isFlagged;
          })
        );
        setIsCreateNewRow(false);
      } else {
        setData((prevData) => {
          const newShiftsMap = new Map(
            allShifts.map((shift) => [shift.id, shift])
          );

          const updatedPrevData = prevData.map((item) =>
            newShiftsMap.has(item.id) ? newShiftsMap.get(item.id) : item
          );

          const prevDataIds = new Set(prevData.map((item) => item.id));
          const newItems = allShifts.filter(
            (shift) => !prevDataIds.has(shift.id)
          );

          return [...updatedPrevData, ...newItems]
            .filter((item) => item.id !== deleteId)
            .sort((a, b) => b.isFlagged - a.isFlagged);
        });
      }
    } else if (allShifts && allShifts.length === 0 && pageNum === 1) {
      setData([]);
      setIsCreateNewRow(false);
      setIsCreate(false);
      setFormErrors({});
    }
    setIsEdit(false);
    setIsLoading(false);
  }, [allShifts]);

  const handleAddRow = useCallback(() => {
    setIsCreateNewRow(true);
    fetchData(pagination.TotalPages ?? 1, perPageItems > 10 ? perPageItems - 5 : perPageItems - 3)
  }, []);

  useEffect(() => {
    if (createShift) {
      setIsCreate(true);
      setCreateShift(false);
    }
  }, [createShift, setCreateShift]);

  const formBody = () => {
    return (
      <>
        <div className="d-flex align-items-start w-100 mb-3">
          <InputUnderline
            inputUnderlinewd="w-100"
            isRequired
            placeholder="Shift name"
            value={name}
            handleChange={setName}
            error={formErrors.name}
            loading={isLoading}
          />
        </div>
        <div className="d-flex align-items-start w-100 mb-4">
          <Input
            inputwd="w-50 me-3"
            label="Start Time"
            icon={<MeetingsClockIcon />}
            placeholder="00:00"
            value={startTime}
            type="time"
            handleChange={setStartTime}
            errorMessage={formErrors.startTime}
            isRequired
            loading={isLoading}
          />
          <Input
            inputwd="w-50"
            label="End Time"
            icon={<MeetingsClockIcon />}
            placeholder="00:00"
            value={endTime}
            type="time"
            handleChange={setEndTime}
            errorMessage={formErrors.endTime}
            isRequired
            loading={isLoading}
          />
        </div>
        {!isLoading && showIsDefault && (
          <div className="d-flex align-items-start">
            {/* <ModalCheckbox
              label="Mark as Default"
              checked={isDefault}
              setChecked={() => setIsDefault(!isDefault)}
            /> */}
            <ModalCheckbox
              label="Mark as Default"
              checked={isDefault}
              setChecked={setIsDefault}
            />
          </div>
        )}
        {/* {(!isDefault) && <div className="d-flex align-items-start">
          <ModalCheckbox label="Mark as Default" checked={isDefault} setChecked={() => setIsDefault(!isDefault)} />
        </div>} */}
      </>
    );
  };

  useEffect(() => {
    if (name) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        name: "",
      }));
    }
    if (startTime) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        startTime: "",
      }));
    }
    if (endTime) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        endTime: "",
      }));
    }
  }, [startTime, endTime, name]);

  useEffect(() => {
    if (errors !== "") {
      setFormErrors({});
      errors &&
        Object.keys(errors).forEach((key) => {
          if (key === "Name") {
            setFormErrors((prevErrors) => ({
              ...prevErrors,
              name: errors[key][0],
            }));
          }
          if (key === "StartTime") {
            setFormErrors((prevErrors) => ({
              ...prevErrors,
              startTime: errors[key][0],
            }));
          }
          if (key === "EndTime") {
            setFormErrors((prevErrors) => ({
              ...prevErrors,
              endTime: errors[key][0],
            }));
          }
        });
    } else {
      setFormErrors({});
    }
  }, [errors]);

  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes("resource-planner")) {
      setIsHeader(false);
    }
  }, []);

  const [isDisable, setIsDisable] = useState(false);

  useEffect(() => {
    if (loading) setIsDisable(true);
    else setIsDisable(false);
  }, [loading]);

  const handleSearchTrigger = (searchTerm) => {
    if ((!tableSearch && !searchTerm) || (tableSearch === searchTerm)) return;

    let pageNumber = pageNum;
    if (!tableSearch || (tableSearch && !searchTerm) || (tableSearch !== searchTerm)) {
      setData([]); //clear existing data
      pageNumber = 1; //reset to first page
      setPageNum(1);
    }

    setTableSearch(searchTerm);
    fetchData(pageNumber, perPageItems, searchTerm, !searchTerm);

  };
  
  return (
    <ColumnConfigProvider tableName="Shift">
      <div className="listingScreen position-relative">
        {isHeader && (
          <div className="db_Subheader d-flex justify-content-between align-items-center mb-4">
            <h4>Shifts</h4>
            {permissions?.includes("Shift.Create") && (
              <Button
                btnClass="d_btn d_btn_primary"
                icon={<AddIconSvg />}
                label="Add Shift"
                clickHandler={handleCreate}
              />
            )}
          </div>
        )}

        <Table
          parentType={parentType}
          isHeader={isHeader}
          type="Shift"
          rows={data || []}
          searchHandler={handleSearch}
          body={formBody()}
          saveBtnLabel="Save"
          cancelBtnLabel="Cancel"
          setPageNum={setPageNum}
          perPageItems={perPageItems}
          setIsCreate={setIsCreate}
          handleSave={() => handleSave()}
          handleDelete={(selectedRow) => handleDelete(selectedRow)}
          handleCancel={() => handleCancel()}
          setIsEdit={setIsEdit}
          loading={pageLoading}
          modalLoading={loading}
          isCreate={isCreate}
          pagination={pagination}
          setData={setData}
          setSelectedRow={setSelectedRow}
          handleAddRow={handleAddRow}
          handleCancelAddRow={handleCancelAddRow}
          triggerSearch={handleSearchTrigger}
        />
      </div>
    </ColumnConfigProvider>
  );
};

export default Shifts;
